{
  "name": "footer",
  "type": "module",
  "private": true,
  "contributors": [
    {
      "name": "Quentin Guillemin",
      "email": "quentin.guillemin@recia.fr",
      "url": "https://github.com/Quentin-Guillemin"
    }
  ],
  "license": "Apache-2.0",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/r-footer.js"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/r-footer.js"
      }
    },
    "./types/*": "./src/types/*"
  },
  "main": "./dist/r-footer.js",
  "module": "./dist/r-footer.js",
  "scripts": {
    "dev": "vite --host",
    "build": "tsc && vite build",
    "preview": "vite preview",
    "test:unit": "echo No tests available"
  },
  "dependencies": {
    "@lit/localize": "^0.12.2",
    "lit": "^3.3.3"
  },
  "devDependencies": {
    "@antfu/eslint-config": "^9.3.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@gip-recia/ui": "workspace:^",
    "@lit/localize-tools": "^0.8.2",
    "@types/lodash-es": "^4",
    "@types/node": "^24",
    "@typescript/native": "npm:typescript@^7.0.2",
    "common": "workspace:^",
    "eslint": "^10.9.1",
    "eslint-plugin-format": "^2.0.1",
    "lodash-es": "^4.18.1",
    "ress": "^6.0.0",
    "sass": "^1.103.1",
    "typescript": "npm:@typescript/typescript6@^6.0.2",
    "unplugin-dts": "^1.0.3",
    "vite": "^8.2.2"
  }
}
